(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initProductFaq() {
    document.querySelectorAll('.product-faq').forEach(function(root) {
      if (root.dataset.productFaqInitialized === 'true') {
        return;
      }

      root.dataset.productFaqInitialized = 'true';

      root.querySelectorAll('.product-faq__question').forEach(function(button) {
        if (button.dataset.productFaqQuestionInitialized === 'true') {
          return;
        }

        button.dataset.productFaqQuestionInitialized = 'true';

        var answerId = button.getAttribute('aria-controls');
        var answer = document.getElementById(answerId);
        var icon = button.querySelector('.product-faq__icon');

        if (!answer) {
          return;
        }

        button.addEventListener('click', function() {
          var isExpanded =
            button.getAttribute('aria-expanded') === 'true';

          button.setAttribute(
            'aria-expanded',
            String(!isExpanded)
          );

          answer.hidden = isExpanded;

          if (icon) {
            icon.textContent = isExpanded ? '＋' : '−';
          }
        });
      });
    });
  }

  initProductFaq();

  document.addEventListener(
    'shopify:section:load',
    initProductFaq
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regalo-product-condition"] && !Shopify.designMode) return;
  try {
    
function initAccordion() {
  document.querySelectorAll('.product-info-accordion__trigger').forEach(function(btn) {
    var content = btn.nextElementSibling;

    if (window.innerWidth >= 750) {
      btn.setAttribute('aria-expanded', 'true');
      content.hidden = false;
      return;
    }

    btn.setAttribute('aria-expanded', 'false');
    content.hidden = true;

    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      content.hidden = expanded;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAccordion);
} else {
  initAccordion();
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regalo-product-detail"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initAccordion() {
    document.querySelectorAll('.product-info-accordion__trigger').forEach(function(btn) {
      if (btn.dataset.accordionInit) return;
      btn.dataset.accordionInit = 'true';

      var content = btn.nextElementSibling;

      if (window.innerWidth >= 750) {
        btn.setAttribute('aria-expanded', 'true');
        content.classList.add('is-open');
        return;
      }

      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        content.classList.toggle('is-open', !expanded);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regalo-product-information"] && !Shopify.designMode) return;
  try {
    
function initAccordion() {
  document.querySelectorAll('.product-info-accordion__trigger').forEach(function(btn) {
    var content = btn.nextElementSibling;

    if (btn.dataset.accordionInit) return;
    btn.dataset.accordionInit = 'true';

    btn.setAttribute('aria-expanded', 'false');
    content.classList.remove('is-open'); // 念のためリセット

    btn.addEventListener('click', function() {
      if (window.innerWidth >= 750) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      content.classList.toggle('is-open', !expanded);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAccordion);
} else {
  initAccordion();
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regalo-product-warranty"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initRegaloWarrantyAccordions() {
    var sections = document.querySelectorAll('.regalo-warranty-section');

    sections.forEach(function(root) {
      if (root.dataset.regaloWarrantyInitialized === 'true') {
        return;
      }

      root.dataset.regaloWarrantyInitialized = 'true';

      var triggers = root.querySelectorAll(
        '.regalo-warranty-accordion__trigger'
      );

      triggers.forEach(function(trigger) {
        if (trigger.dataset.regaloWarrantyTriggerInitialized === 'true') {
          return;
        }

        trigger.dataset.regaloWarrantyTriggerInitialized = 'true';

        var contentId = trigger.getAttribute('aria-controls');
        var content = document.getElementById(contentId);
        var icon = trigger.querySelector(
          '.regalo-warranty-accordion__icon'
        );

        if (!content) {
          return;
        }

        trigger.addEventListener('click', function() {
          var isExpanded =
            trigger.getAttribute('aria-expanded') === 'true';

          trigger.setAttribute(
            'aria-expanded',
            String(!isExpanded)
          );

          content.hidden = isExpanded;
          content.classList.toggle('is-open', !isExpanded);

          if (icon) {
            icon.textContent = isExpanded ? '＋' : '−';
          }
        });
      });
    });
  }

  initRegaloWarrantyAccordions();

  document.addEventListener(
    'shopify:section:load',
    initRegaloWarrantyAccordions
  );
})();

  } catch(e) { console.error(e); }
})();
})();
